// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb408556","453":"01b19e0a","455":"6ec043c9"}[chunkId] + ".chunk.js";
};